/**
 * Nostrion protocol utilities — compatible with the NIP-XX Encrypted File Sync spec.
 */

/**
 * Generate a random UUID v4 using the Web Crypto API.
 * The NIP requires random UUID v4 d-tags for kind 30800 and 30801 events
 * to prevent correlation attacks.
 */
export function generateUUID(): string {
  return crypto.randomUUID();
}

/**
 * Calculate a SHA-256 checksum of a string using the Web Crypto API.
 * Returns a hex-encoded string as specified in the NIP.
 */
export async function calculateChecksum(content: string): Promise<string> {
  const bytes = new TextEncoder().encode(content);
  const hashBuffer = await crypto.subtle.digest('SHA-256', bytes);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
